export default __webpack_public_path__ + "static/media/logo.973a6927.png";